import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-font-text" }

import mutations from '@/profile-creation-wizard/store/creation/mutations';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {useStore} from 'vuex';
    import {ref, onMounted} from 'vue';
    import {useTranslation} from '@malt/vue3-use';
    import PriceSelection from '@/profile-creation-wizard/components/for-creation/ui/dailyRate/PriceSelection.vue';

    const dataHeapTooltipID = 'profile-creation-tooltip-price';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'PriceSelectionStrategy',
  setup(__props) {

    const store = useStore();
    const {msg} = useTranslation();

    const priceSelection = ref(null);
    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);

    onMounted(async () => {
        bottomSheetDisplayer.value = new BottomSheetDisplayer(
            '#details-price-bottom-sheet',
            dataHeapTooltipID,
            priceSelection.value,
            'div.profile-creation-wizard',
        );
        store.commit(mutations.selectPriceHide, true);
    });

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "priceSelection",
    ref: priceSelection
  }, [
    _createElementVNode("h2", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.details.price.title')), 1),
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.details.price.strategy.subtitle')) + " ", 1),
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        "data-heap": dataHeapTooltipID,
        onClick: openBottomSheet
      }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.details.price.help')), 1)
    ]),
    _createVNode(PriceSelection)
  ], 512))
}
}

})